<template>
  <div class="services-page">
    <!-- Hero -->
    <section class="hero">
      <div class="hero-overlay"></div>
      <div class="hero-content">
        <h1 data-aos="fade-down">Nos Services</h1>
        <p data-aos="fade-up" data-aos-delay="200">Des solutions sur mesure en Management des Ressources Humaines</p>
      </div>
    </section>

    <div class="container">
      <!-- Services Grid -->
      <section class="section-block">
        <div class="text-center mb-5" data-aos="fade-up">
          <div class="section-label">Ce que nous faisons</div>
          <h2>Une gamme complete de services RH</h2>
          <p class="section-subtitle">Depuis 2012, nous accompagnons les entreprises dans la gestion et l'optimisation de leur capital humain</p>
        </div>

        <div class="services-grid">
          <div v-for="(service, index) in services" :key="index"
               class="service-card"
               :data-aos="'fade-up'"
               :data-aos-delay="index * 80">
            <div class="service-icon" :style="{ background: service.gradient }">
              <i :class="service.icon"></i>
            </div>
            <h3>{{ service.title }}</h3>
            <p>{{ service.description }}</p>
            <ul class="service-features">
              <li v-for="(feature, i) in service.features" :key="i">
                <i class="fas fa-check"></i> {{ feature }}
              </li>
            </ul>
          </div>
        </div>
      </section>

      <!-- Processus de recrutement -->
      <section class="section-block process-section" data-aos="fade-up">
        <div class="text-center mb-5">
          <div class="section-label">Notre methodologie</div>
          <h2>Processus de recrutement</h2>
          <p class="section-subtitle">Un processus rigoureux pour identifier les meilleurs talents</p>
        </div>
        <div class="process-timeline">
          <div v-for="(step, index) in processSteps" :key="index" class="process-step"
               :data-aos="'fade-up'" :data-aos-delay="index * 100">
            <div class="step-number">{{ index + 1 }}</div>
            <div class="step-content">
              <h4>{{ step.title }}</h4>
              <p>{{ step.text }}</p>
            </div>
          </div>
        </div>
      </section>

      <!-- Chiffres cles -->
      <section class="section-block stats-section" data-aos="fade-up">
        <div class="stats-grid">
          <div v-for="(stat, index) in stats" :key="index" class="stat-card" :data-aos="'zoom-in'" :data-aos-delay="index * 100">
            <div class="stat-value">{{ stat.value }}</div>
            <div class="stat-label">{{ stat.label }}</div>
          </div>
        </div>
      </section>

      <!-- CTA -->
      <section class="section-block" data-aos="fade-up">
        <div class="cta-box">
          <h2>Un besoin en recrutement ou en formation ?</h2>
          <p>Notre equipe est a votre disposition pour etudier votre projet</p>
          <div class="cta-actions">
            <router-link to="/contact" class="btn btn-cta">
              <i class="fas fa-paper-plane me-2"></i>Demander un devis
            </router-link>
            <a href="tel:+22901401188884" class="btn btn-cta-outline">
              <i class="fas fa-phone-alt me-2"></i>01 40 11 88 84
            </a>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import AOS from "aos";
import "aos/dist/aos.css";

export default {
  name: "ServicesPage",
  data() {
    return {
      services: [
        {
          icon: "fas fa-user-tie",
          title: "Recrutement & Chasse de tete",
          gradient: "linear-gradient(135deg, #29b3cd, #1d9ed9)",
          description: "Identifiez les meilleurs talents grace a notre processus de recrutement eprouve et notre vivier de candidats qualifies.",
          features: ["Mise a disposition de CV", "Preselection sur dossier", "Tests psychotechniques", "Appui aux entretiens", "Prise de references"]
        },
        {
          icon: "fas fa-graduation-cap",
          title: "Formation & Coaching",
          gradient: "linear-gradient(135deg, #e95d16, #bc6a3c)",
          description: "Renforcez les competences de vos equipes avec nos formations inter et intra entreprises animees par des experts seniors.",
          features: ["Catalogue de 48+ formations/an", "Formations sur mesure", "Coaching individuel", "Suivi post-formation", "Attestations de participation"]
        },
        {
          icon: "fas fa-tools",
          title: "Etudes & Developpement d'outils",
          gradient: "linear-gradient(135deg, #29b3cd, #1d9ed9)",
          description: "Concevez et mettez en oeuvre les outils strategiques pour la gestion optimale de vos ressources humaines.",
          features: ["Plan strategique & procedures", "Convention collective", "Cadre organique", "GPEC & bilans competences", "Audit social et organisationnel"]
        },
        {
          icon: "fas fa-users-cog",
          title: "Assistance & Conseils en GRH",
          gradient: "linear-gradient(135deg, #e95d16, #bc6a3c)",
          description: "Beneficiez d'un accompagnement expert pour la gestion quotidienne de vos ressources humaines.",
          features: ["Gestion du personnel", "Formalites sociales (CNSS, IPTS)", "Formation de vos RH", "Coaching & developpement", "Mise a disposition de personnel"]
        },
        {
          icon: "fas fa-cogs",
          title: "Consulting & Ingenierie RH",
          gradient: "linear-gradient(135deg, #29b3cd, #1d9ed9)",
          description: "Transformez votre fonction RH avec nos solutions d'ingenierie et de conseil personnalisees.",
          features: ["Ingenierie de formation", "Conception plans de formation", "Evaluation des actions formation", "Relooking CV", "Politiques & procedures RH"]
        },
        {
          icon: "fas fa-chart-line",
          title: "Evaluation de projets & programmes",
          gradient: "linear-gradient(135deg, #e95d16, #bc6a3c)",
          description: "Evaluez et optimisez l'impact de vos projets et programmes de developpement.",
          features: ["Etudes prospectives", "Evaluation de projets", "Programmes de developpement", "Recherche & Developpement", "Gestion financiere & comptable"]
        },
      ],
      processSteps: [
        { title: "Prise de contact & cadrage", text: "Entretien physique ou virtuel pour cerner le profil recherche et la culture de votre entreprise." },
        { title: "Sourcing des candidats", text: "Recherche via notre vivier interne, job boards, reseaux sociaux et approche directe." },
        { title: "Preselection & Tests", text: "Administration de tests metiers et psychotechniques selon les domaines d'activite." },
        { title: "Entretiens approfondis", text: "Entretiens structures en presentiel ou a distance avec les candidats retenus." },
        { title: "Verification des references", text: "Controle systematique des references professionnelles et des parcours." },
        { title: "Rapport & Short-list", text: "Rapport succinct contenant un short-list final avec recommandations detaillees." },
      ],
      stats: [
        { value: "14+", label: "Annees d'experience" },
        { value: "2 000+", label: "Heures de formation" },
        { value: "50+", label: "Entreprises partenaires" },
        { value: "11", label: "Domaines d'expertise" },
      ]
    };
  },
  mounted() {
    document.querySelector("body").style.backgroundColor = "#ffffff";
    // AOS initialise globalement dans main.js
    this.$nextTick(() => AOS.refresh());
  }
};
</script>

<style scoped>
.services-page {
  font-family: 'Poppins', sans-serif;
  color: #2c3e50;
}

.hero {
  background: url('../assets/img/bg-navbar.jpg') center/cover no-repeat;
  height: 45vh;
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: white;
  position: relative;
}

.hero-overlay {
  position: absolute; top: 0; left: 0; right: 0; bottom: 0;
  background: linear-gradient(135deg, rgba(41,179,205,0.85), rgba(233,93,22,0.7));
  z-index: 1;
}

.hero-content { position: relative; z-index: 2; padding: 0 1rem; }
.hero-content h1 { font-size: 2.8rem; font-weight: 700; }
.hero-content p { font-size: 1.2rem; opacity: 0.95; }

.section-block { padding: 4rem 0; }
.section-block + .section-block { border-top: 1px solid #eef2f6; }

.section-label {
  display: inline-block;
  background: linear-gradient(135deg, #29b3cd, #1d9ed9);
  color: white;
  padding: 4px 14px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 1rem;
}

h2 { font-size: 2rem; font-weight: 700; color: #2c3e50; margin-bottom: 0.8rem; }
.section-subtitle { color: #6c757d; font-size: 1.05rem; max-width: 600px; margin: 0 auto; }

/* Services Grid */
.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 1.5rem;
}

.service-card {
  background: #fff;
  border-radius: 16px;
  padding: 2rem;
  border: 1px solid #eef2f6;
  transition: all 0.3s;
}

.service-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 35px rgba(0,0,0,0.08);
}

.service-icon {
  width: 56px; height: 56px;
  border-radius: 14px;
  display: flex; align-items: center; justify-content: center;
  margin-bottom: 1.2rem;
}

.service-icon i { font-size: 1.4rem; color: white; }

.service-card h3 { font-size: 1.15rem; font-weight: 700; margin-bottom: 0.5rem; }
.service-card > p { font-size: 0.9rem; color: #6c757d; line-height: 1.6; margin-bottom: 1rem; }

.service-features {
  list-style: none;
  padding: 0;
  margin: 0;
}

.service-features li {
  padding: 4px 0;
  font-size: 0.85rem;
  color: #4a5568;
}

.service-features li i {
  color: #29b3cd;
  margin-right: 8px;
  font-size: 0.75rem;
}

/* Process Timeline */
.process-timeline {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.5rem;
}

.process-step {
  display: flex;
  gap: 1rem;
  padding: 1.5rem;
  background: #f8f9fa;
  border-radius: 12px;
  transition: all 0.3s;
}

.process-step:hover {
  background: white;
  box-shadow: 0 8px 25px rgba(0,0,0,0.06);
}

.step-number {
  width: 40px; height: 40px; min-width: 40px;
  background: linear-gradient(135deg, #29b3cd, #1d9ed9);
  color: white;
  border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  font-weight: 700;
  font-size: 1rem;
}

.step-content h4 { font-size: 0.95rem; font-weight: 600; margin-bottom: 0.3rem; }
.step-content p { font-size: 0.85rem; color: #6c757d; margin: 0; }

/* Stats */
.stats-section {
  background: linear-gradient(135deg, #29b3cd, #1d9ed9);
  border-radius: 20px;
  padding: 3rem !important;
  margin: 2rem 0;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 1.5rem;
}

.stat-card { text-align: center; color: white; }
.stat-value { font-size: 2.5rem; font-weight: 800; line-height: 1; margin-bottom: 0.3rem; }
.stat-label { font-size: 0.9rem; opacity: 0.9; }

/* CTA */
.cta-box {
  text-align: center;
  padding: 3rem 2rem;
  background: #f8f9fa;
  border-radius: 20px;
  margin-bottom: 2rem;
}

.cta-box h2 { color: #2c3e50; font-size: 1.8rem; }
.cta-box p { color: #6c757d; margin-bottom: 1.5rem; }

.cta-actions {
  display: flex; gap: 1rem; justify-content: center; flex-wrap: wrap;
}

.btn-cta {
  background: #e95d16; color: white; padding: 12px 28px;
  border-radius: 50px; font-weight: 600; border: 2px solid #e95d16; transition: all 0.3s;
}

.btn-cta:hover { background: #29b3cd; border-color: #29b3cd; color: white; }

.btn-cta-outline {
  background: transparent; color: #29b3cd; padding: 12px 28px;
  border-radius: 50px; font-weight: 600; border: 2px solid #29b3cd; transition: all 0.3s; text-decoration: none;
}

.btn-cta-outline:hover { background: #29b3cd; color: white; }

@media (max-width: 768px) {
  .hero-content h1 { font-size: 2rem; }
  .services-grid { grid-template-columns: 1fr; }
  .process-timeline { grid-template-columns: 1fr; }
  .stats-section { padding: 2rem !important; }
  .stat-value { font-size: 2rem; }
}

@media (max-width: 575px) {
  .hero-content h1 { font-size: 1.5rem; }
  .hero-content p { font-size: 1rem; }
  .stat-value { font-size: 1.6rem; }
  .stats-grid { grid-template-columns: repeat(2, 1fr); }
}
</style>
